"use client";

import { Button } from "@workspace/ui/components";
import { ChevronDown } from "lucide-react";
import { useState } from "react";
import { motion, MotionConfig } from "motion/react";
import { cn } from "@workspace/ui/lib/utils";

const QUESTIONS = [
  {
    question: "How does the 30-day risk-free guarantee work?",
    answer:
      "If you sign up for an annual plan and decide Yolk isn't for your team within the first 30 days, simply contact us. We'll issue a full refund, no questions asked.",
  },
  { question: "Can we add or remove users?", answer: "Yes! On the Team plan, you can easily add or remove user seats at any time from your billing portal. Your account will be pro-rated accordingly." },
  { question: "Can we downgrade or cancel our plan anytime?", answer: "Absolutely. You can manage your subscription directly from your admin dashboard. You can downgrade or cancel at any time, and your plan will remain active through the end of your current billing period." },
];
export const FAQ = () => {
  const [opened, setOpened] = useState<Record<number, boolean>>({});

  const toggle = (idx: number) => {
    setOpened((prev) => ({ ...prev, [idx]: !prev[idx] }));
  };
  return (
    <div className="flex flex-col items-center justify-center w-full px-5">
      <span className="text-[32px] lg:text-[42px] font-extrabold mb-10">
        FAQ
      </span>
      <div className="flex flex-col w-full max-w-[678px] gap-4">
        {QUESTIONS.map(({ question, answer }, i) => (
          <MotionConfig key={i} transition={{ duration: 0.3 }}>
            <motion.div
              layout
              initial={false}
              animate={opened[i] ? "open" : "closed"}
              className="flex flex-col rounded-[20px] border border-[#f4e7b1] bg-white"
            >
              <div className="flex px-5 items-center h-[72px] min-h-[72px]">
                <span className="rounded-full bg-[#f3e2c3] size-7 min-w-7 flex items-center justify-center mr-5 font-extrabold">
                  {i + 1}
                </span>
                <span className="w-full font-medium pr-10">{question}</span>
                <Button
                  variant="d-default"
                  className="size-10"
                  onClick={() => toggle(i)}
                >
                  <ChevronDown
                    className={cn(
                      "transition-transform duration-200",
                      opened[i] && "rotate-180",
                    )}
                  />
                </Button>
              </div>
              <motion.span
                variants={{
                  open: { height: "auto" },
                  closed: { height: 0 },
                }}
                className="px-[68px] text-[#5B5540] text-sm tracking-[-0.28px] leading-[22px] overflow-hidden"
              >
                <motion.p
                  className="pb-5"
                  variants={{
                    open: {
                      filter: "blur(0px)",
                      opacity: 1,
                    },
                    closed: {
                      filter: "blur(2px)",
                      opacity: 0,
                    },
                  }}
                >
                  {answer}
                </motion.p>
              </motion.span>
            </motion.div>
          </MotionConfig>
        ))}
      </div>
    </div>
  );
};
